class AddToCart extends HTMLElement {
  onSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData(this.form);

    const allowedKeys = ["id", "quantity"];
    const data = {};

    // Add each name/value pair to the object
    for (const [name, value] of formData) {
      const property = /properties\[(?<propertyKey>.+)\]/gm.exec(name);

      if (property || allowedKeys.includes(name)) {
        if (!property) {
          data[name] = value;
        } else {
          if (!("properties" in data)) {
            data.properties = {};
          }
          data.properties[property.groups.propertyKey] = value;
        }
      }
    }

    if (!("quantity" in data)) {
      data.quantity = 1;
    }

    data.quantity = parseInt(data.quantity, 10);

    window.addToCart(data, {
      onError: (response) => {
        // Per-field errors, e.g. gift card recipient fields, for components
        // inside this form to show next to their inputs. A component that
        // shows them cancels the event, which replaces the generic banner.
        const handled =
          response?.errors &&
          !this.form.dispatchEvent(
            new CustomEvent("cart:errors", {
              cancelable: true,
              detail: { errors: response.errors },
            }),
          );

        if (handled) return;

        this.showError(
          response?.message || window.localeStrings.product.add_to_cart_error,
        );
      },
      onAfterAdd: () => {
        document.dispatchEvent(new CustomEvent("mini-cart:open"));
      },
    });
  };

  connectedCallback() {
    this.button = this.closest("button");
    this.form = this.button?.form;

    this.form?.addEventListener("submit", this.onSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener("submit", this.onSubmit);
    clearTimeout(this.errorTimeout);
  }

  showError(message) {
    const error = document.createElement("div");
    error.classList.add("add-to-cart-error");
    error.textContent = message;

    this.form.append(error);

    clearTimeout(this.errorTimeout);
    this.errorTimeout = setTimeout(() => {
      error.remove();
    }, 3000);
  }
}

if (!customElements.get("add-to-cart")) {
  customElements.define("add-to-cart", AddToCart);
}
